export const productCategories = [
  { id: 'shoes', name: 'Shoes', nameEn: 'Shoes', icon: 'ri-footprint-line' },
  { id: 'hoodies-sweaters', name: 'Hoodies/Sweaters', nameEn: 'Hoodies/Sweaters', icon: 'ri-t-shirt-line' },
  { id: 't-shirts', name: 'T-Shirts', nameEn: 'T-Shirts', icon: 'ri-t-shirt-air-line' },
  { id: 'jackets', name: 'Jackets', nameEn: 'Jackets', icon: 'ri-shirt-line' },
  { id: 'pants-shorts', name: 'Pants/Shorts', nameEn: 'Pants/Shorts', icon: 'ri-shirt-line' },
  { id: 'headwear', name: 'Headwear', nameEn: 'Headwear', icon: 'ri-user-2-line' },
  { id: 'sets', name: 'Sets', nameEn: 'Sets', icon: 'ri-shirt-line' },
  { id: 'underwear', name: 'underwear/underpants', nameEn: 'Underwear/Underpants', icon: 'ri-shirt-line' },
  { id: 'jersey', name: 'Jersey', nameEn: 'Jersey', icon: 'ri-t-shirt-air-line' },
  { id: 'accessories', name: 'Accessories', nameEn: 'Accessories', icon: 'ri-time-line' },
  { id: 'bags', name: 'Bags', nameEn: 'Bags', icon: 'ri-shopping-bag-2-line' },
  { id: 'belts', name: 'Belts', nameEn: 'Belts', icon: 'ri-vip-crown-line' },
  { id: 'perfumes', name: 'Perfumes', nameEn: 'Perfumes', icon: 'ri-drop-line' },
  { id: 'other', name: 'Other Stuff', nameEn: 'Other Stuff', icon: 'ri-more-line' },
];

export interface Product {
  id: string;
  name: string;
  priceYuan: string;
  priceUsd: string;
  imageUrl: string;
  productUrl: string;
  categoryId: string;
}

export const products: Product[] = [
  // Shoes
  {
    id: '136312',
    name: 'Black Canvas Combat Boots with Side Zippers and Lace-Up Design',
    priceYuan: '¥678',
    priceUsd: '$94.17',
    imageUrl: 'https://si.geilicdn.com/open1775823299-1234478995-52da00000198bbc54c190aa0c791_620_620.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-136312.html',
    categoryId: 'shoes',
  },
  {
    id: '136311',
    name: 'Louis Vuitton Archlight White Monogram Print Sneakers',
    priceYuan: '¥397',
    priceUsd: '$55.14',
    imageUrl: 'https://si.geilicdn.com/open1623462477-1234478995-6f9600000194e2901d1a0a239383_800_600.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-136311.html',
    categoryId: 'shoes',
  },
  {
    id: '136310',
    name: 'Rick Owens Geobasket High-Top Sneaker Black White Contrast Toe',
    priceYuan: '¥585',
    priceUsd: '$81.25',
    imageUrl: 'https://si.geilicdn.com/open1623462477-1234478995-1a000000019749d603be0a22d249_1200_1200.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-136310.html',
    categoryId: 'shoes',
  },
  {
    id: '136309',
    name: 'Off-White Diagonal Arrow Low-Top Sneakers - White/Black',
    priceYuan: '¥300',
    priceUsd: '$41.67',
    imageUrl: 'https://si.geilicdn.com/pcitem1513127982-3b200000019667fbebea0a21146b_1200_1200.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-136309.html',
    categoryId: 'shoes',
  },
  {
    id: '136308',
    name: 'Nike Tiempo Legend 9 IC Indoor Court Soccer Shoes - Multicolor',
    priceYuan: '¥268',
    priceUsd: '$37.22',
    imageUrl: 'https://si.geilicdn.com/open1623462477-1234478995-6f9000000194b81466ec0aa08290_800_800.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-136308.html',
    categoryId: 'shoes',
  },
  {
    id: '136307',
    name: 'Louis Vuitton Archlight Star Motif Sneaker - Beige Snake Print',
    priceYuan: '¥528',
    priceUsd: '$73.33',
    imageUrl: 'https://si.geilicdn.com/pcitem1871933355-69ef00000190a56ff3d40a8133cc_1200_1200.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-136307.html',
    categoryId: 'shoes',
  },
  {
    id: '136306',
    name: 'Louis Vuitton Trainer Low Monogram Canvas Sneaker Red White',
    priceYuan: '¥297',
    priceUsd: '$41.25',
    imageUrl: 'https://si.geilicdn.com/wdseller901862032983-53ff00000190603e9a530a2102c5_1170_1173.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-136306.html',
    categoryId: 'shoes',
  },
  {
    id: '136305',
    name: 'Off-White Diagonal Arrow Low-Top Sneakers Black-White',
    priceYuan: '¥258',
    priceUsd: '$35.83',
    imageUrl: 'https://si.geilicdn.com/open1648936853-1234478995-38cd000001977cd8cc7d0a231226_1200_1200.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-136305.html',
    categoryId: 'shoes',
  },

  // Hoodies/Sweaters
  {
    id: '138084',
    name: 'OFFSETTEARS Black Hoodie with Orange Floral Graphic and Signature Print',
    priceYuan: '¥186',
    priceUsd: '$25.83',
    imageUrl: 'https://si.geilicdn.com/open1648936853-1234478995-6bc000000194965ed7d10a239383_1920_1920.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-138084.html',
    categoryId: 'hoodies-sweaters',
  },
  {
    id: '137567',
    name: 'Supreme Margiela Paris 1994 Zip-Up Hoodie Skull Lining Black',
    priceYuan: '¥136',
    priceUsd: '$18.89',
    imageUrl: 'https://si.geilicdn.com/open1648936853-1234478995-4ad900000199c30f90a50aa0229a_1280_1280.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-137567.html',
    categoryId: 'hoodies-sweaters',
  },
  {
    id: '137459',
    name: 'BAPE x Inter Miami CF Camo Hoodie Pink Black Gray',
    priceYuan: '¥141',
    priceUsd: '$19.58',
    imageUrl: 'https://si.geilicdn.com/open1815288597-1234478995-0c480000019791690d9a0a8133b0_1200_1200.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-137459.html',
    categoryId: 'hoodies-sweaters',
  },
  {
    id: '137449',
    name: 'Dior Oblique Monogram Logo Applique White Sweatshirt',
    priceYuan: '¥176',
    priceUsd: '$24.44',
    imageUrl: 'https://si.geilicdn.com/open1623462477-1234478995-679b00000195474e9a2d0a8115c2_1125_1125.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-137449.html',
    categoryId: 'hoodies-sweaters',
  },
  {
    id: '137348',
    name: 'Nike Lost Repeat Graphic Fleece Crewneck Sweatshirt - Cream Green',
    priceYuan: '¥274',
    priceUsd: '$38.06',
    imageUrl: 'https://si.geilicdn.com/pcitem1945679661-278900000198c64832cd0a20e2c5_945_1280.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-137348.html',
    categoryId: 'hoodies-sweaters',
  },
  {
    id: '137303',
    name: 'BOSS Embossed Logo Crewneck Sweatshirt - Black',
    priceYuan: '¥141',
    priceUsd: '$19.58',
    imageUrl: 'https://si.geilicdn.com/open1648936853-1234478995-4dc8000001977c8963190a8133b0_1024_1024.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-137303.html',
    categoryId: 'hoodies-sweaters',
  },
  {
    id: '137105',
    name: 'Polo Ralph Lauren Cable Knit Short-Sleeve Crewneck Sweater - Pink',
    priceYuan: '¥148',
    priceUsd: '$20.56',
    imageUrl: 'https://si.geilicdn.com/open1623462477-1234478995-7dfe000001955822c0a80a22d249_1200_1200.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-137105.html',
    categoryId: 'hoodies-sweaters',
  },
  {
    id: '137044',
    name: 'Burberry Rainbow Equestrian Knight Logo White Sweatshirt',
    priceYuan: '¥155',
    priceUsd: '$21.53',
    imageUrl: 'https://si.geilicdn.com/pcitem1886196013-3fe800000195989eafd90a210256_1200_1200.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-137044.html',
    categoryId: 'hoodies-sweaters',
  },

  // T-Shirts
  {
    id: '138192',
    name: 'Nike Dri-FIT Cotton T-Shirt with 1972 Logo Print - Black',
    priceYuan: '¥112',
    priceUsd: '$15.56',
    imageUrl: 'https://si.geilicdn.com/open1648936853-1234478995-529a000001977c85cb740a231226_800_800.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-138192.html',
    categoryId: 't-shirts',
  },
  {
    id: '138188',
    name: 'Louis Vuitton x Malletier Navy T-Shirt with White Rabbit Graphic',
    priceYuan: '¥175',
    priceUsd: '$24.31',
    imageUrl: 'https://si.geilicdn.com/open1623462477-1234478995-2e0f00000196ab5b18160a8133b0_1080_1080.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-138188.html',
    categoryId: 't-shirts',
  },
  {
    id: '138187',
    name: 'Stussy World Tour Polo Shirt - White/Black with Lion & Billiard Ball',
    priceYuan: '¥169',
    priceUsd: '$23.47',
    imageUrl: 'https://si.geilicdn.com/open1623462477-1234478995-0017000001974412c93c0a23b491_1024_1024.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-138187.html',
    categoryId: 't-shirts',
  },
  {
    id: '138186',
    name: 'FENDI Dragon Graphic T-Shirt Black',
    priceYuan: '¥109',
    priceUsd: '$15.14',
    imageUrl: 'https://si.geilicdn.com/open1648936853-1234478995-3868000001955b71f6390a23b491_1080_1080.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-138186.html',
    categoryId: 't-shirts',
  },
  {
    id: '138185',
    name: 'Palm Angels Bear Graphic T-Shirt Black',
    priceYuan: '¥139',
    priceUsd: '$19.31',
    imageUrl: 'https://si.geilicdn.com/open1623462477-1234478995-3d10000001952f1af3560a23b491_1000_1000.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-138185.html',
    categoryId: 't-shirts',
  },
  {
    id: '138183',
    name: 'Rhude Premium Cigars Logo Graphic T-Shirt Black',
    priceYuan: '¥98',
    priceUsd: '$13.61',
    imageUrl: 'https://si.geilicdn.com/open1623462477-1234478995-214100000195c9825ed90a8133b0_1200_1200.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-138183.html',
    categoryId: 't-shirts',
  },
  {
    id: '138182',
    name: 'Valentino VLogo Embroidered Black T-Shirt with Pink Logo',
    priceYuan: '¥150',
    priceUsd: '$20.83',
    imageUrl: 'https://si.geilicdn.com/open1718885333-1234478995-4cd50000019648d7af310a23b491-unadjust_475_522.png',
    productUrl: 'https://kaspreadsheet.com/goods-138182.html',
    categoryId: 't-shirts',
  },
  {
    id: '138181',
    name: 'Cole Buxton Dog Logo Graphic T-Shirt Black',
    priceYuan: '¥124',
    priceUsd: '$17.22',
    imageUrl: 'https://si.geilicdn.com/open1648936853-1234478995-096700000197974c396b0a22d249_1280_1280.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-138181.html',
    categoryId: 't-shirts',
  },

  // Jackets
  {
    id: '136582',
    name: 'Under Armour Storm Rain Jacket Black with Reflective Logo',
    priceYuan: '¥118',
    priceUsd: '$16.39',
    imageUrl: 'https://si.geilicdn.com/open1767724244-1234478995-69310000019715c9e1c30a8133b0_800_800.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-136582.html',
    categoryId: 'jackets',
  },
  {
    id: '136303',
    name: 'Louis Vuitton Monogram Print Hooded Windbreaker Jacket Black',
    priceYuan: '¥472',
    priceUsd: '$65.56',
    imageUrl: 'https://si.geilicdn.com/open1742170557-1234478995-7b50000001977caa02d80a22d249_1276_1702.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-136303.html',
    categoryId: 'jackets',
  },
  {
    id: '136284',
    name: 'A BATHING APE Denim Jacket with Embroidered Cross Motif',
    priceYuan: '¥288',
    priceUsd: '$40.00',
    imageUrl: 'https://si.geilicdn.com/open1648936853-1234478995-7e94000001943acc82ee0a239383_1000_1000.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-136284.html',
    categoryId: 'jackets',
  },
  {
    id: '136276',
    name: 'Zara Butterfly Logo Fleece Track Jacket Navy Purple Stripes',
    priceYuan: '¥190',
    priceUsd: '$26.39',
    imageUrl: 'https://si.geilicdn.com/open1675136579-1234478995-66aa00000198a68a28e10a231226_1200_1200.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-136276.html',
    categoryId: 'jackets',
  },
  {
    id: '136203',
    name: 'Canada Goose Crofton Vest Black Quilted Down Puffer Vest',
    priceYuan: '¥329',
    priceUsd: '$45.69',
    imageUrl: 'https://si.geilicdn.com/open1623462477-1234478995-0d9d00000194c30b210a0a210559_800_800.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-136203.html',
    categoryId: 'jackets',
  },
  {
    id: '136189',
    name: 'Louis Vuitton Monogram Quilted Puffer Jacket - Gray Black',
    priceYuan: '¥260',
    priceUsd: '$36.11',
    imageUrl: 'https://si.geilicdn.com/pcitem901971869584-335c00000199bdf837270a23111a_1280_1280.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-136189.html',
    categoryId: 'jackets',
  },
  {
    id: '136181',
    name: 'Canada Goose Youth Expedition Parka - Arctic Camo with Fur Trim',
    priceYuan: '¥590',
    priceUsd: '$81.94',
    imageUrl: 'https://si.geilicdn.com/open1623462477-1234478995-4c51000001952f1d25bb0aa0834c_1200_1200.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-136181.html',
    categoryId: 'jackets',
  },
  {
    id: '135968',
    name: 'Prada RDAPA Logo Tape Track Jacket White Black',
    priceYuan: '¥517',
    priceUsd: '$71.81',
    imageUrl: 'https://si.geilicdn.com/open1648936853-1234478995-3e840000019769c4fcd30a8115c2_800_800.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-135968.html',
    categoryId: 'jackets',
  },

  // Pants/Shorts
  {
    id: '137495',
    name: 'OceanView Cruise Logo Shorts - Pink Cotton Blend',
    priceYuan: '¥94',
    priceUsd: '$13.06',
    imageUrl: 'https://si.geilicdn.com/open1877254536-1234478995-1a74000001972b942b510a8115c2_800_800.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-137495.html',
    categoryId: 'pants-shorts',
  },
  {
    id: '137207',
    name: 'Prada Re-Nylon Triangle Logo Swim Shorts - Black',
    priceYuan: '¥153',
    priceUsd: '$21.25',
    imageUrl: 'https://si.geilicdn.com/open1691309225-1234478995-51a700000196d91ec6a60aa0834c_2560_2560.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-137207.html',
    categoryId: 'pants-shorts',
  },
  {
    id: '136530',
    name: '1230 Holy Holy Graphic Shorts - Black Mesh Side Panel',
    priceYuan: '¥142',
    priceUsd: '$19.72',
    imageUrl: 'https://si.geilicdn.com/open1648936853-1234478995-1d6c00000197494076c30a22d249-unadjust_900_900.png',
    productUrl: 'https://kaspreadsheet.com/goods-136530.html',
    categoryId: 'pants-shorts',
  },
  {
    id: '136300',
    name: 'Balenciaga Rainbow Logo Washed Light Grey Denim Jeans',
    priceYuan: '¥280',
    priceUsd: '$38.89',
    imageUrl: 'https://si.geilicdn.com/open1623462477-1234478995-78d400000196c048651b0a231226_1442_1922.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-136300.html',
    categoryId: 'pants-shorts',
  },
  {
    id: '136286',
    name: 'DEPT de la GALERIE Paint-Splatter Track Pants White',
    priceYuan: '¥169',
    priceUsd: '$23.47',
    imageUrl: 'https://si.geilicdn.com/open1648936853-1234478995-606c00000193dded32260a22d234_800_800.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-136286.html',
    categoryId: 'pants-shorts',
  },
  {
    id: '136266',
    name: 'Gucci GG Monogram Print Drawstring Shorts - White/Navy',
    priceYuan: '¥110',
    priceUsd: '$15.28',
    imageUrl: 'https://si.geilicdn.com/open1718885333-1234478995-71b10000019648fa027e0a231226_1200_1200.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-136266.html',
    categoryId: 'pants-shorts',
  },
  {
    id: '136257',
    name: 'Nike Run Air Force 1 Black Jogger Pants with Side Logo',
    priceYuan: '¥120',
    priceUsd: '$16.67',
    imageUrl: 'https://si.geilicdn.com/open1623462477-1234478995-70e300000196c03ef9eb0a231226_1440_1920.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-136257.html',
    categoryId: 'pants-shorts',
  },
  {
    id: '136249',
    name: 'Moncler Diagonal Stripe Shorts - White with Red Accent',
    priceYuan: '¥199',
    priceUsd: '$27.64',
    imageUrl: 'https://si.geilicdn.com/open1623462477-1234478995-0e490000019558486bc90a8115c2_1200_1200.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-136249.html',
    categoryId: 'pants-shorts',
  },

  // Headwear
  {
    id: '133388',
    name: 'New Era 59FIFTY MLB Authentic On-Field Cap - Black LA Dodgers Palm Tree',
    priceYuan: '¥170',
    priceUsd: '$23.61',
    imageUrl: 'https://si.geilicdn.com/open1821611651-1234478995-7ca3000001984ac153c70aa043f9_1137_1137.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-133388.html',
    categoryId: 'headwear',
  },
  {
    id: '133383',
    name: 'Burberry Logo Knit Beanie Hat - Gray with Black Band',
    priceYuan: '¥112',
    priceUsd: '$15.56',
    imageUrl: 'https://si.geilicdn.com/open1815288597-1234478995-73f50000019767422ae30a22d249_1074_1074.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-133383.html',
    categoryId: 'headwear',
  },
  {
    id: '133370',
    name: 'alo Reflective Visor with Embossed Logo - Black Silver',
    priceYuan: '¥81',
    priceUsd: '$11.25',
    imageUrl: 'https://si.geilicdn.com/open1767724244-1234478995-31420000019672781d5b0a8133b0_1200_1200.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-133370.html',
    categoryId: 'headwear',
  },
  {
    id: '133369',
    name: 'Gucci GG Monogram Beige Mesh Baseball Cap with Brown Trim',
    priceYuan: '¥110',
    priceUsd: '$15.28',
    imageUrl: 'https://si.geilicdn.com/open1811769437-1234478995-544b0000019764bb73ad0aa0c79f-unadjust_886_849.png',
    productUrl: 'https://kaspreadsheet.com/goods-133369.html',
    categoryId: 'headwear',
  },
  {
    id: '133362',
    name: 'SYNER Graffiti Knit Beanie Hat - Neon Green/Black Contrast',
    priceYuan: '¥81',
    priceUsd: '$11.25',
    imageUrl: 'https://si.geilicdn.com/open1612884413-1234478995-1c6c000001977e57fb830a231226_1280_1280.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-133362.html',
    categoryId: 'headwear',
  },
  {
    id: '133349',
    name: 'Dior Oblique Monogram Baseball Cap Black-White Pattern',
    priceYuan: '¥99',
    priceUsd: '$13.75',
    imageUrl: 'https://si.geilicdn.com/open1648936853-1234478995-6e3400000195457be2de0a231226_1200_1200.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-133349.html',
    categoryId: 'headwear',
  },
  {
    id: '133343',
    name: 'New Era 59FIFTY MLB Los Angeles Dodgers Floral Blue Cap',
    priceYuan: '¥99',
    priceUsd: '$13.75',
    imageUrl: 'https://si.geilicdn.com/open1623462477-1234478995-4bc600000194e27f91c20a232357-unadjust_900_900.png',
    productUrl: 'https://kaspreadsheet.com/goods-133343.html',
    categoryId: 'headwear',
  },
  {
    id: '133342',
    name: 'Stone Island Compass Logo Bucket Hat - Gray with Drawstring',
    priceYuan: '¥58',
    priceUsd: '$8.06',
    imageUrl: 'https://si.geilicdn.com/pcitem901908522262-348800000195413652c40a2395d6-unadjust_500_500.gif',
    productUrl: 'https://kaspreadsheet.com/goods-133342.html',
    categoryId: 'headwear',
  },

  // Sets
  {
    id: '138191',
    name: 'Nike Dri-FIT Academy Soccer Jersey and Shorts Set - Black/White',
    priceYuan: '¥144',
    priceUsd: '$20.00',
    imageUrl: 'https://si.geilicdn.com/open1648936853-1234478995-15a700000197493e80b70a8133b0_800_800.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-138191.html',
    categoryId: 'sets',
  },
  {
    id: '138184',
    name: 'Stone Island Compass Logo Short Set - White',
    priceYuan: '¥175',
    priceUsd: '$24.31',
    imageUrl: 'https://si.geilicdn.com/open1742154973-1234478995-22160000019769f3aee70aa0c79f_1200_1200.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-138184.html',
    categoryId: 'sets',
  },
  {
    id: '138178',
    name: 'Gucci GG Monogram Print Short-Sleeve Shirt and Shorts Set Beige',
    priceYuan: '¥154',
    priceUsd: '$21.39',
    imageUrl: 'https://si.geilicdn.com/open1648936853-1234478995-44260000019779312b2c0aa0c79f_1200_1200.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-138178.html',
    categoryId: 'sets',
  },
  {
    id: '138161',
    name: 'Real Madrid 2023-24 Training Kit Navy Yellow V-Neck Jersey Shorts Set',
    priceYuan: '¥139',
    priceUsd: '$19.31',
    imageUrl: 'https://si.geilicdn.com/open1648936853-1234478995-0675000001973f6663200a23b4de_1200_1200.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-138161.html',
    categoryId: 'sets',
  },
  {
    id: '138159',
    name: 'BOSS Black Track Suit with Beige Logo Stripes and Zipper Front',
    priceYuan: '¥177',
    priceUsd: '$24.58',
    imageUrl: 'https://si.geilicdn.com/pcitem1944626857-760e0000019773c369f50a239846_1200_1200.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-138159.html',
    categoryId: 'sets',
  },
  {
    id: '138154',
    name: 'ALLSTAR Flame Graphic T-Shirt and Shorts Set - Black with Neon Green Flames',
    priceYuan: '¥315',
    priceUsd: '$43.75',
    imageUrl: 'https://si.geilicdn.com/open1824078381-1234478995-3ab900000196a5bc0b000a8115c2_800_800.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-138154.html',
    categoryId: 'sets',
  },
  {
    id: '138153',
    name: 'Stone Island Compass Logo Short Set - Pink Cotton Twill',
    priceYuan: '¥270',
    priceUsd: '$37.50',
    imageUrl: 'https://si.geilicdn.com/open1811769437-1234478995-0fa9000001973f4d55700a23b4de_800_800.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-138153.html',
    categoryId: 'sets',
  },
  {
    id: '138135',
    name: 'Versace Logo Print Short-Sleeve Shirt and Shorts Set - Navy Green Pink',
    priceYuan: '¥125',
    priceUsd: '$17.36',
    imageUrl: 'https://si.geilicdn.com/open1623462477-1234478995-53280000019572c0d6ca0a8115c2_800_800.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-138135.html',
    categoryId: 'sets',
  },

  // Underwear
  {
    id: '136447',
    name: 'Louis Vuitton Monogram Gradient Bodysuit with White Trim',
    priceYuan: '¥159',
    priceUsd: '$22.08',
    imageUrl: 'https://si.geilicdn.com/open1623462477-1234478995-416b0000019572963ee90aa08290_1440_1920.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-136447.html',
    categoryId: 'underwear',
  },
  {
    id: '136200',
    name: 'lululemon Align Soft High-Waisted Underwear with Lace Trim',
    priceYuan: '¥95',
    priceUsd: '$13.19',
    imageUrl: 'https://si.geilicdn.com/open1718885333-1234478995-3e8000000197a64cbaec0a23b491_1080_1441.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-136200.html',
    categoryId: 'underwear',
  },
  {
    id: '136037',
    name: 'Calvin Klein Men\'s Cotton Boxer Briefs - Gray Black Navy',
    priceYuan: '¥29',
    priceUsd: '$4.03',
    imageUrl: 'https://si.geilicdn.com/open1648936853-1234478995-417800000193c49caaea0a210559_1200_1200.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-136037.html',
    categoryId: 'underwear',
  },
  {
    id: '135612',
    name: 'LACOSTE Classic Logo Waistband Boxer Briefs 3-Pack Green White Black',
    priceYuan: '¥99',
    priceUsd: '$13.75',
    imageUrl: 'https://si.geilicdn.com/open1648936853-1234478995-659b00000193ce9623d00a8133b5_800_800.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-135612.html',
    categoryId: 'underwear',
  },
  {
    id: '135596',
    name: 'PSD SpongeBob SquarePants Underwear - Blue Ocean Print Boxer Briefs',
    priceYuan: '¥45',
    priceUsd: '$6.25',
    imageUrl: 'https://si.geilicdn.com/pcitem901950853318-589000000196dd1ae0cf0a81347d_4800_4800.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-135596.html',
    categoryId: 'underwear',
  },
  {
    id: '135593',
    name: 'Calvin Klein Men\'s Cotton Boxer Briefs - Gray Black Navy',
    priceYuan: '¥108',
    priceUsd: '$15.00',
    imageUrl: 'https://si.geilicdn.com/open1783746229-1234478995-7eae000001966daf5aca0a22d249_1200_1200.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-135593.html',
    categoryId: 'underwear',
  },
  {
    id: '135575',
    name: 'Supreme Boxer Briefs Cotton Underwear with Logo Waistband',
    priceYuan: '¥30',
    priceUsd: '$4.17',
    imageUrl: 'https://si.geilicdn.com/open1623462477-1234478995-7ffd000001974a632f450a8133b0_800_800.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-135575.html',
    categoryId: 'underwear',
  },
  {
    id: '135566',
    name: 'Hermes Logo Waistband Boxer Briefs - Black White Yellow',
    priceYuan: '¥34',
    priceUsd: '$4.72',
    imageUrl: 'https://si.geilicdn.com/open1858585309-1234478995-2360000001977d2fc4a40a8133b0_800_800.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-135566.html',
    categoryId: 'underwear',
  },

  // Jersey
  {
    id: '138190',
    name: 'Paris Saint-Germain 2023 Champions of Europe Jersey - Navy Blue',
    priceYuan: '¥106',
    priceUsd: '$14.72',
    imageUrl: 'https://si.geilicdn.com/open1648936853-1234478995-030c000001973f6540060aa0834c_942_983.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-138190.html',
    categoryId: 'jersey',
  },
  {
    id: '138180',
    name: 'PSG Qatar Airways Training Jersey - Red Blue Abstract Pattern',
    priceYuan: '¥165',
    priceUsd: '$22.92',
    imageUrl: 'https://si.geilicdn.com/open1623462477-1234478995-7a2000000195bfc0adac0a8115c2_800_800.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-138180.html',
    categoryId: 'jersey',
  },
  {
    id: '138175',
    name: 'FC Barcelona Lamine Yamal 19 Black Away Jersey 2024-25',
    priceYuan: '¥128',
    priceUsd: '$17.78',
    imageUrl: 'https://si.geilicdn.com/open1623462477-1234478995-025700000195cf19315b0a23b4de_450_450.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-138175.html',
    categoryId: 'jersey',
  },
  {
    id: '138164',
    name: 'Supreme 30th Anniversary Football Jersey - Green Diamond Pattern',
    priceYuan: '¥331',
    priceUsd: '$45.97',
    imageUrl: 'https://si.geilicdn.com/open1648936853-1234478995-1c2d000001974942961f0a23b4de_800_762.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-138164.html',
    categoryId: 'jersey',
  },
  {
    id: '138155',
    name: 'Palmeiras 2023 Home Jersey Yellow Green Crest',
    priceYuan: '¥63',
    priceUsd: '$8.75',
    imageUrl: 'https://si.geilicdn.com/open1675274933-1234478995-19cc000001967ca93aab0a23b491_1202_1202.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-138155.html',
    categoryId: 'jersey',
  },
  {
    id: '138150',
    name: 'Real Madrid 2000-01 Home Jersey White with Black Stripes TeKa Sponsor',
    priceYuan: '¥118',
    priceUsd: '$16.39',
    imageUrl: 'https://si.geilicdn.com/open1623462477-1234478995-66a800000195bfccb6a40a231226_1200_1200.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-138150.html',
    categoryId: 'jersey',
  },
  {
    id: '138148',
    name: 'Adidas x Flame Silhouette Football Jersey - White Black Design',
    priceYuan: '¥99',
    priceUsd: '$13.75',
    imageUrl: 'https://si.geilicdn.com/open1623462477-1234478995-279000000195c9a5168f0aa08290_941_963.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-138148.html',
    categoryId: 'jersey',
  },
  {
    id: '138139',
    name: 'PSG 2023-24 Third Jersey Black with Red-White-Blue Vertical Stripes',
    priceYuan: '¥142',
    priceUsd: '$19.72',
    imageUrl: 'https://si.geilicdn.com/open1648936853-1234478995-7bf5000001975f2f34a10a23b4de_1107_1107.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-138139.html',
    categoryId: 'jersey',
  },

  // Accessories
  {
    id: '137556',
    name: 'Cartier Santos Dumont Square Watch Blue Dial Black Leather Strap',
    priceYuan: '¥599',
    priceUsd: '$83.19',
    imageUrl: 'https://si.geilicdn.com/open1623462477-1234478995-10690000019673cee0e70aa0834c_1200_1200.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-137556.html',
    categoryId: 'accessories',
  },
  {
    id: '137382',
    name: 'Louis Vuitton Monogram World Tour Bracelet - Black Rope with Logo Discs',
    priceYuan: '¥165',
    priceUsd: '$22.92',
    imageUrl: 'https://si.geilicdn.com/open1767724244-1234478995-423700000197160db1620a8133b0_1200_1200.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-137382.html',
    categoryId: 'accessories',
  },
  {
    id: '135965',
    name: 'Apple Watch Series 6 Black Aluminum Case with Black Sport Band',
    priceYuan: '¥170',
    priceUsd: '$23.61',
    imageUrl: 'https://si.geilicdn.com/open1648936853-1234478995-5ea900000193d8cce9290a232357_1024_1024.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-135965.html',
    categoryId: 'accessories',
  },
  {
    id: '135384',
    name: 'Apple Watch Series 9 GPS + Cellular, Black Aluminum Case with Black Sport Band',
    priceYuan: '¥288',
    priceUsd: '$40.00',
    imageUrl: 'https://si.geilicdn.com/open1623462477-1234478995-07640000019673be92750a8115c2_800_800.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-135384.html',
    categoryId: 'accessories',
  },
  {
    id: '135380',
    name: 'Apple Watch Ultra 2 with Purple Woven Band - GPS + Cellular',
    priceYuan: '¥399',
    priceUsd: '$55.42',
    imageUrl: 'https://si.geilicdn.com/open1776978413-1234478995-0d200000019740bb8f220a8115c2_1179_1179.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-135380.html',
    categoryId: 'accessories',
  },
  {
    id: '134538',
    name: 'Apple Watch Ultra 2 with Desert Tan Alpine Loop Band',
    priceYuan: '¥275',
    priceUsd: '$38.19',
    imageUrl: 'https://si.geilicdn.com/open1648936853-1234478995-3047000001927ca712ba0aa08290_1290_1290.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-134538.html',
    categoryId: 'accessories',
  },
  {
    id: '133945',
    name: 'Casio Baby-G G-Lide BGA-210 Digital Watch - Neon Green Resin Case',
    priceYuan: '¥150',
    priceUsd: '$20.83',
    imageUrl: 'https://si.geilicdn.com/open1648936853-1234478995-4a5a000001937c768dab0a210298_1080_810.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-133945.html',
    categoryId: 'accessories',
  },
  {
    id: '133944',
    name: 'Apple Watch Series 7 Black Aluminum with Midnight Sport Band',
    priceYuan: '¥258',
    priceUsd: '$35.83',
    imageUrl: 'https://si.geilicdn.com/open1623462477-1234478995-0fe50000019673cd17830aa0834c_750_750.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-133944.html',
    categoryId: 'accessories',
  },

  // Bags
  {
    id: '135418',
    name: 'SMINDUS TRUO Black Mesh Golf Towel with Pink Logo and Globe Design',
    priceYuan: '¥261',
    priceUsd: '$36.25',
    imageUrl: 'https://si.geilicdn.com/open1648936853-1234478995-44f8000001976cf1b5d50a8115c2-unadjust_500_500.gif',
    productUrl: 'https://kaspreadsheet.com/goods-135418.html',
    categoryId: 'bags',
  },
  {
    id: '134959',
    name: 'Prada Milano Woven Mini Tote Bag - Black Textured with Logo',
    priceYuan: '¥335',
    priceUsd: '$46.53',
    imageUrl: 'https://si.geilicdn.com/open1623462477-1234478995-5c300000019572da6a310a8115c2_1442_1922.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-134959.html',
    categoryId: 'bags',
  },
  {
    id: '133386',
    name: 'Goyard Saint Louis Mini Crossbody Bag Pink Chevron Pattern',
    priceYuan: '¥165',
    priceUsd: '$22.92',
    imageUrl: 'https://si.geilicdn.com/pcitem901900035971-74aa000001938a89828e0a23041a_1000_1333.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-133386.html',
    categoryId: 'bags',
  },
  {
    id: '133276',
    name: 'Louis Vuitton Monogram Canvas Tote Bag Brown with Tan Leather Trim',
    priceYuan: '¥139',
    priceUsd: '$19.31',
    imageUrl: 'https://si.geilicdn.com/pcitem901891552790-1ba50000019390628c620a2396f4_1200_1200.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-133276.html',
    categoryId: 'bags',
  },
  {
    id: '133272',
    name: 'Chanel 25P Kelly Mini Bag Beige Quilted Lambskin Top Handle Chain',
    priceYuan: '¥374',
    priceUsd: '$51.94',
    imageUrl: 'https://si.geilicdn.com/open1823866485-1234478995-534900000195a49cb72e0a8133b0_1080_1439.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-133272.html',
    categoryId: 'bags',
  },
  {
    id: '133264',
    name: 'Chanel White Quilted Double Flap Bucket Bag with Gold CC Logo',
    priceYuan: '¥199',
    priceUsd: '$27.64',
    imageUrl: 'https://si.geilicdn.com/open1623462477-1234478995-74c600000195475287920a23b4de_1200_1200.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-133264.html',
    categoryId: 'bags',
  },
  {
    id: '133244',
    name: 'Goyard Saint-Louis PM Tote Bag in Green Chevron Canvas',
    priceYuan: '¥138',
    priceUsd: '$19.17',
    imageUrl: 'https://si.geilicdn.com/open1757144309-1234478995-5bcc0000019698dce2c40a22d249_1200_1200.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-133244.html',
    categoryId: 'bags',
  },
  {
    id: '133226',
    name: 'Louis Vuitton Allin BB Monogram Empreinte Black Bucket Bag',
    priceYuan: '¥546',
    priceUsd: '$75.83',
    imageUrl: 'https://si.geilicdn.com/ch1931865500-1a9400000197741d80650a230115_1920_1440.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-133226.html',
    categoryId: 'bags',
  },

  // Belts
  {
    id: '133199',
    name: 'Fendi FF Logo Belt with Gold Silver Yellow Blue Buckle',
    priceYuan: '¥146',
    priceUsd: '$20.28',
    imageUrl: 'https://si.geilicdn.com/open1623462477-1234478995-1bb200000197910d6d570a22d249_1000_1000.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-133199.html',
    categoryId: 'belts',
  },
  {
    id: '133145',
    name: 'AMIRI Logo Buckle Belt White Leather with Gold Hardware',
    priceYuan: '¥95',
    priceUsd: '$13.19',
    imageUrl: 'https://si.geilicdn.com/open1623462477-1234478995-482a000001952f0b7ef60aa0834c-unadjust_936_925.png',
    productUrl: 'https://kaspreadsheet.com/goods-133145.html',
    categoryId: 'belts',
  },
  {
    id: '133079',
    name: 'Hermes H-Pin Buckle Leather Belt - Multi-Color Distressed Finish',
    priceYuan: '¥142',
    priceUsd: '$19.72',
    imageUrl: 'https://si.geilicdn.com/open1623462477-1234478995-400500000195c492a20b0a23b4de_800_800.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-133079.html',
    categoryId: 'belts',
  },
  {
    id: '133074',
    name: 'Dior Oblique Pattern Belt with CD Buckle - Gray Black Silver Gold',
    priceYuan: '¥128',
    priceUsd: '$17.78',
    imageUrl: 'https://si.geilicdn.com/open1623462477-1234478995-0eb600000194e1e8290b0a232357_800_800.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-133074.html',
    categoryId: 'belts',
  },
  {
    id: '133059',
    name: 'Valentino Garavani VLogo Belt in Multiple Colors',
    priceYuan: '¥68',
    priceUsd: '$9.44',
    imageUrl: 'https://si.geilicdn.com/open1858585309-1234478995-07e4000001977db6177b0a8133b0_2560_3413.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-133059.html',
    categoryId: 'belts',
  },
  {
    id: '133045',
    name: 'Burberry Black Check-Print Leather Belt with Monogram Buckle',
    priceYuan: '¥85',
    priceUsd: '$11.81',
    imageUrl: 'https://si.geilicdn.com/open1648936853-1234478995-3d6100000193b49f9e400a210298_1276_1702.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-133045.html',
    categoryId: 'belts',
  },
  {
    id: '133023',
    name: 'Fendi FF Logo Belt Black Leather with Gold Silver Black Buckles',
    priceYuan: '¥139',
    priceUsd: '$19.31',
    imageUrl: 'https://si.geilicdn.com/open1623462477-1234478995-191100000195c48b97cd0a231226-unadjust_500_375.gif',
    productUrl: 'https://kaspreadsheet.com/goods-133023.html',
    categoryId: 'belts',
  },
  {
    id: '133021',
    name: 'Cartelostyle Geometric Pattern Leather Belt with G-Shape Buckle',
    priceYuan: '¥76',
    priceUsd: '$10.56',
    imageUrl: 'https://si.geilicdn.com/open1648936853-1234478995-58e500000193d93330f30a210559-unadjust_783_842.png',
    productUrl: 'https://kaspreadsheet.com/goods-133021.html',
    categoryId: 'belts',
  },

  // Perfumes
  {
    id: '138044',
    name: 'Delina 75ml Pink Perfume Bottle with Tassel Cap and Elegant Design',
    priceYuan: '¥148',
    priceUsd: '$20.56',
    imageUrl: 'https://si.geilicdn.com/pcitem1945403796-045400000196c304bc950a239846_1199_1199.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-138044.html',
    categoryId: 'perfumes',
  },
  {
    id: '133255',
    name: 'Gucci Bloom Floral Print 5-Piece Mini Perfume Set with Gift Box',
    priceYuan: '¥130',
    priceUsd: '$18.06',
    imageUrl: 'https://si.geilicdn.com/open1742154973-1234478995-508b00000197a7e361940aa0c791_800_800.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-133255.html',
    categoryId: 'perfumes',
  },
  {
    id: '133248',
    name: 'Gucci Bloom Floral Print 5-Piece Mini Perfume Set with Gift Box',
    priceYuan: '¥109',
    priceUsd: '$15.14',
    imageUrl: 'https://si.geilicdn.com/open1623462477-1234478995-121600000194c3615f810a22d234_800_800.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-133248.html',
    categoryId: 'perfumes',
  },
  {
    id: '133247',
    name: 'Yves Saint Laurent La Nuit de L\'Homme Eau de Parfum Black Bottle',
    priceYuan: '¥108',
    priceUsd: '$15.00',
    imageUrl: 'https://si.geilicdn.com/open1823866485-1234478995-03e300000197841b99f20a231226_800_800.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-133247.html',
    categoryId: 'perfumes',
  },
  {
    id: '133207',
    name: 'Chanel Chance Eau Tendre Perfume - Pink Bottle with Gold Cap',
    priceYuan: '¥108',
    priceUsd: '$15.00',
    imageUrl: 'https://si.geilicdn.com/open1648936853-1234478995-0ef200000194882a14e00a232357_1200_1200.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-133207.html',
    categoryId: 'perfumes',
  },
  {
    id: '133204',
    name: 'Harrods The Exclusive Collection Perfume 100ml Gold Bottle',
    priceYuan: '¥159',
    priceUsd: '$22.08',
    imageUrl: 'https://si.geilicdn.com/open1623462477-1234478995-6a8d00000196f49bdc7b0a231226_1280_1280.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-133204.html',
    categoryId: 'perfumes',
  },
  {
    id: '133051',
    name: 'MCM Visetos Mini Bag Perfume Bottle Shape Gold Logo Print',
    priceYuan: '¥324',
    priceUsd: '$45.00',
    imageUrl: 'https://si.geilicdn.com/pcitem1968774131-48c200000197ede4c4dd0a23037f_1080_1080.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-133051.html',
    categoryId: 'perfumes',
  },
  {
    id: '133038',
    name: 'Gucci Bloom Floral Print Mini Perfume 5-Piece Gift Set',
    priceYuan: '¥141',
    priceUsd: '$19.58',
    imageUrl: 'https://si.geilicdn.com/open1742154973-1234478995-508b00000197a7e361940aa0c791_800_800.jpg',
    productUrl: 'https://kaspreadsheet.com/goods-133038.html',
    categoryId: 'perfumes',
  },
];

export const getProductsByCategory = (categoryId: string) =>
  products.filter((p) => p.categoryId === categoryId);

export const getProductsByCategoryUrl = (categoryId: string) => {
  const catMap: Record<string, string> = {
    shoes: 'https://kaspreadsheet.com/category-911-Shoes.html',
    'hoodies-sweaters': 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html',
    't-shirts': 'https://kaspreadsheet.com/category-913-T-Shirts.html',
    jackets: 'https://kaspreadsheet.com/category-914-Jackets.html',
    'pants-shorts': 'https://kaspreadsheet.com/category-915-Pants%2FShorts.html',
    headwear: 'https://kaspreadsheet.com/category-916-Headwear.html',
    sets: 'https://kaspreadsheet.com/category-917-Sets.html',
    underwear: 'https://kaspreadsheet.com/category-918-underwear%2Funderpants.html',
    jersey: 'https://kaspreadsheet.com/category-919-Jersey.html',
    accessories: 'https://kaspreadsheet.com/category-920-Accessories.html',
    bags: 'https://kaspreadsheet.com/category-921-Bags.html',
    belts: 'https://kaspreadsheet.com/category-922-Belts.html',
    perfumes: 'https://kaspreadsheet.com/category-923-Perfumes.html',
    other: 'https://kaspreadsheet.com/category-924-Other+Stuff.html',
  };
  return catMap[categoryId] || 'https://kaspreadsheet.com';
};

export const getCategoryById = (categoryId: string) =>
  productCategories.find((c) => c.id === categoryId);